import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Modifier from 'ember-modifier';
import { service } from '@ember/service';
import { registerDestructor } from '@ember/destroyable';
import { getOwner } from '@ember/application';

var _class, _descriptor;

// The same reason re-tapped inside this window does not stack a second toast.
const REPEAT_MS = 2500;
const REASON_MS = 6000;
let NvDisabledReasonModifier = (_class = class NvDisabledReasonModifier extends Modifier {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "notify", _descriptor, this);
    this.element = null;
    this.reason = null;
    this.lastShown = 0;
    this.setTitle = false;
    // classic fallback set the native disabled itself (no `busy=` owner): undone when the reason clears
    this.setDisabled = false;
    this.guard = event => {
      if (!this.reason) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.explain();
    };
    // Enter / Space on a focused <a role=button> or custom control: same refusal.
    this.guardKey = event => {
      if (!this.reason || event.key !== 'Enter' && event.key !== ' ') return;
      if (event.target !== this.element) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.explain();
    };
    registerDestructor(this, () => this.detach());
  }

  // service:ui is optional (an app without it renders the classic UI); `isNuova` is tracked, so a UI switch re-runs
  // modify and the control flips between the two behaviours without a re-render.
  get isNuova() {
    return Boolean(getOwner(this)?.lookup('service:ui')?.isNuova);
  }
  modify(element, [reason], named) {
    if (this.element !== element) {
      this.detach();
      this.element = element;
      element.addEventListener('click', this.guard, true);
      element.addEventListener('keydown', this.guardKey, true);
    }
    const nuova = this.isNuova;
    const why = reason ? String(reason) : null;
    const ownsDisabled = 'busy' in named;
    if (!nuova) {
      // classic: the control is natively disabled exactly as before, no explanation layer
      this.reason = null;
      this.clearAttrs(element);
      if (ownsDisabled) {
        element.disabled = Boolean(named.busy) || Boolean(why);
      } else if (why || this.setDisabled) {
        element.disabled = Boolean(why);
        this.setDisabled = Boolean(why);
      }
      return;
    }
    if (ownsDisabled) {
      element.disabled = Boolean(named.busy);
    } else if (this.setDisabled) {
      element.disabled = false;
      this.setDisabled = false;
    }
    this.reason = why;
    if (this.reason) {
      element.setAttribute('aria-disabled', 'true');
      element.setAttribute('data-disabled-reason', this.reason);
      if (!element.hasAttribute('title') || this.setTitle) {
        element.setAttribute('title', this.reason);
        this.setTitle = true;
      }
    } else {
      this.clearAttrs(element);
    }
  }
  clearAttrs(element) {
    if (element.getAttribute('data-disabled-reason') !== null) {
      element.removeAttribute('aria-disabled');
      element.removeAttribute('data-disabled-reason');
    }
    if (this.setTitle) {
      element.removeAttribute('title');
      this.setTitle = false;
    }
  }
  detach() {
    const el = this.element;
    if (!el) return;
    el.removeEventListener('click', this.guard, true);
    el.removeEventListener('keydown', this.guardKey, true);
    this.element = null;
  }
  explain() {
    const now = Date.now();
    if (now - this.lastShown < REPEAT_MS) return;
    this.lastShown = now;
    // a reason is a sentence to read, not a flash: longer than ember-notify's default 2.5s
    this.notify?.info?.(this.reason, {
      closeAfter: REASON_MS
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "notify", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { NvDisabledReasonModifier as default };
//# sourceMappingURL=nv-disabled-reason.js.map
